<footer class="border-t border-slate-200 bg-slate-50 pb-28 text-sm text-slate-600 sm:pb-0">
  <cm-locations-map />

  <div class="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:grid-cols-2 lg:grid-cols-4">
    <div class="min-w-0">
      <a routerLink="/" class="inline-flex items-center gap-2" [attr.aria-label]="site().brand.name + ' - Trang chủ'">
        <img
          src="assets/Green_Energy_Mobility_Logo-removebg-preview.png"
          alt=""
          class="h-9 w-9 object-contain"
        />
        <span class="text-lg font-bold text-slate-900">{{ site().brand.name }}</span>
      </a>
      <p class="mt-3 leading-relaxed">{{ site().footer.description }}</p>
      <ul class="mt-3 space-y-1.5">
        <li class="flex items-start gap-2">
          <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:place"></mat-icon>
          <span>{{ site().contact.address }}</span>
        </li>
        <li class="flex items-start gap-2">
          <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:schedule"></mat-icon>
          <span>{{ site().contact.workingHours }}</span>
        </li>
      </ul>
    </div>

    <div>
      <p class="mb-3 border-b-2 border-emerald-600 pb-2 text-sm font-bold uppercase text-slate-900">Chính sách</p>
      <ul class="space-y-2">
        @for (item of policies; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>

    <div>
      <p class="mb-3 border-b-2 border-emerald-600 pb-2 text-sm font-bold uppercase text-slate-900">Hướng dẫn</p>
      <ul class="space-y-2">
        @for (item of guides; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>

    <div class="min-w-0">
      <p class="mb-3 border-b-2 border-emerald-600 pb-2 text-sm font-bold uppercase text-slate-900">
        {{ site().footer.contactHeading }}
      </p>
      <ul class="space-y-2">
        <li class="flex items-start gap-2">
          <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:phone"></mat-icon>
          <a [href]="'tel:' + site().contact.phone" class="font-semibold text-slate-800 hover:text-emerald-700">{{ site().contact.phoneLabel }} {{ site().contact.phoneDisplay }}</a>
        </li>
        <li class="flex items-start gap-2">
          <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:mail"></mat-icon>
          <a [href]="'mailto:' + site().contact.email" class="break-all hover:text-emerald-700">{{ site().contact.email }}</a>
        </li>
        @if (site().contact.zaloUrl) {
          <li class="flex items-start gap-2">
            <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:forum"></mat-icon>
            <a [href]="site().contact.zaloUrl" target="_blank" rel="noopener" class="hover:text-emerald-700">Zalo</a>
          </li>
        }
        @if (site().contact.facebookUrl) {
          <li class="flex items-start gap-2">
            <mat-icon class="mt-0.5 !h-4 !w-4 shrink-0 text-emerald-600" svgIcon="hero:open_in_new"></mat-icon>
            <a [href]="site().contact.facebookUrl" target="_blank" rel="noopener" class="hover:text-emerald-700">Facebook</a>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="border-t border-slate-200 bg-white">
    <div class="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
      <p>{{ site().footer.copyright }}</p>
      <nav [attr.aria-label]="'Liên kết chân trang'">
        <ul class="flex flex-wrap gap-x-4 gap-y-1">
          @for (link of links; track link.path) {
            <li>
              <a [routerLink]="link.path" class="hover:text-emerald-700">{{ link.label }}</a>
            </li>
          }
        </ul>
      </nav>
    </div>
  </div>
</footer>

<!-- Nút gọi nhanh cố định -->
<div class="fixed bottom-4 right-4 z-30 flex flex-col items-end gap-2">
  @if (site().contact.zaloUrl) {
    <a
      [href]="site().contact.zaloUrl"
      target="_blank"
      rel="noopener"
      class="inline-flex h-11 items-center gap-2 rounded-full bg-sky-700 px-4 text-sm font-semibold text-white shadow-md hover:bg-sky-800"
      aria-label="Chat Zalo"
    >
      <mat-icon svgIcon="hero:forum"></mat-icon>
      Zalo
    </a>
  }
  <a
    [href]="'tel:' + site().contact.phone"
    class="inline-flex h-11 items-center gap-2 rounded-full bg-emerald-700 px-4 text-sm font-semibold text-white shadow-md hover:bg-emerald-800"
    [attr.aria-label]="'Gọi ' + site().contact.phoneDisplay"
  >
    <mat-icon svgIcon="hero:phone"></mat-icon>
    <span class="hidden sm:inline">{{ site().contact.phoneDisplay }}</span>
  </a>
</div>
